import { useCallback, useEffect, useContext, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import style from './Header.module.css'
import HamburgerMenu from './HamburgerMenu'
import IconWhite from '../../../assets/svgs/IconWhite'
import IconHover from '../../../assets/svgs/IconHover'
import Auth from '../../../utils/AuthModal'
import useWindowWidth from '../../../hooks/useWindowWidth'
import { useAuthContext } from '../../../contexts/AuthContext'
import useScrollMenu from '../../../hooks/useScrollMenu'
import GuestContext from '../../../contexts/GuestContext'

const Header = ({ openReg, openAuth, setOpenAuth, handleAuth }) => {
  const navigate = useNavigate()
  const location = useLocation()
  // ...

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const auth = params.get('auth')
    if (auth === 'login' || auth === 'register') {
      handleAuth(true)
      setOpenAuth(auth)
      navigate(location.pathname, { replace: true })
    }
  }, [location.search, location.pathname, navigate, handleAuth, setOpenAuth])
  const innerWidth = useWindowWidth()
  const [manual, setManual] = useState(true)
  const { yAxis, openMenu, setOpenMenu } = useScrollMenu(manual)
  const { logout } = useAuthContext()
  const { setOpenGuestInfo } = useContext(GuestContext)
  const loggedIn = document.cookie.includes('token')
  const url = process.env.REACT_APP_API_URL || ''
  // 1) Centralize scroll lock here
  useEffect(() => {
    const el = document.documentElement
    if (openMenu && innerWidth < 768) {
      el.classList.add('disable-scroll')
    } else {
      el.classList.remove('disable-scroll')
    }
    return () => el.classList.remove('disable-scroll')
  }, [openMenu, innerWidth])

  // 2) Reusable closer
  const closeMenu = useCallback(() => {
    setOpenMenu(false)
    setManual(true)
  }, [setOpenMenu])

  const handleClick = () => {
    setOpenMenu(!openMenu)
    setManual(!manual)
  }

  const handleNavigation = (path, sectionId) => {
    // ensure menu is closed and scroll is unlocked
    if (openMenu) closeMenu()

    navigate(path)
    setTimeout(() => {
      const section = sectionId ? document.getElementById(sectionId) : null
      if (section) section.scrollIntoView({ behavior: 'smooth' })
    }, 200)
  }

  const handleLogout = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(`${url}/users/logout`, { method: 'GET' })
      if (!response.ok) throw new Error('Logout request failed')
      logout()
      navigate('/')
      console.log('Logout successful')
    } catch (error) {
      console.error('Error logging out:', error.message)
    }
  }

  const renderMenuItems = () => (
    <>
      <p
        className={style.singleMenuItem}
        onClick={() => handleNavigation('/', '')}
      >
        Home
      </p>
      <p
        className={style.singleMenuItem}
        onClick={() => handleNavigation('/', 'bot-hero')}
      >
        About
      </p>
      <p
        className={style.singleMenuItem}
        onClick={() => handleNavigation('/', 'team')}
      >
        Team
      </p>
      <p
        className={style.singleMenuItem}
        onClick={() => handleNavigation('/', 'milestones')}
      >
        Our Journey
      </p>
      <p
        className={style.singleMenuItem}
        onClick={() => handleNavigation('/', 'contact')}
      >
        Contact
      </p>
      {loggedIn ? (
        <p className={style.singleMenuItem} onClick={(e) => { closeMenu(); handleLogout(e); }}>
          Log out
        </p>
      ) : (
        <p
          className={style.singleMenuItem}
          onClick={() => {
            closeMenu()
            handleAuth(true)
            setOpenAuth('login')
          }}
        >
          Log in
        </p>
      )}
      <button
        className={style.menuButton}
        onClick={() => {
          closeMenu()
          handleAuth(true)
          setOpenAuth('login')   // select the login tab
        }}
      >
        Try it now
      </button>
    </>
  )

  return (
    <>
      <div className={style.cover}></div>
      <div className={`${style.container} ${yAxis > 1 ? style.stickyNav : ''}`}>
        <div className={style.subContainer}>
          <div className={style.iconContainer}>
            <div
              className="chimpIcon"
              onClick={() => handleNavigation('/', '')}
            >
              <IconWhite />
              <IconHover />
            </div>
          </div>
          <div className={style.menuContainer}>
            <div
              className={`${style.menuItems} ${
                openMenu ? style.menuItemsVisible : ''
              }`}
              style={{ pointerEvents: openMenu ? 'auto' : 'none' }}
            >
              {renderMenuItems()}
            </div>
            <div
              className={`${openMenu ? style.menuBackground : ''} ${
                openMenu ? style.open : style.closed
              }`}
              onClick={closeMenu}
            ></div>
            <div
              className={`${style.mobileMenu} ${
                openMenu ? style.open : style.closed
              }`}
            >
              <div
                className={style.HamburgerMenuMobile}
                onClick={handleClick}
              ></div>
              {renderMenuItems()}
            </div>
            <div onClick={handleClick} className={style.hamburger}>
              <HamburgerMenu
                isOpen={openMenu}
                toggleMenu={() => setOpenMenu(!openMenu)}
              />
            </div>
          </div>
        </div>
      </div>
      {openReg && (
        <div className={style.form}>
          <Auth
            handleAuth={handleAuth}
            openReg={openReg}
            openAuth={openAuth}
            setOpenAuth={setOpenAuth}
          />
        </div>
      )}
    </>
  )
}

export default Header
